import React from "react";

function CustomerExperience() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="30"
            fill="none"
            viewBox="0 0 28 30"
        >
            <path
                fill="#000"
                d="M15.153 3.303a.671.671 0 00-.671.672v.56a7.997 7.997 0 00-7.249 7.266h-.577a.671.671 0 100 1.342h.574a7.96 7.96 0 007.252 7.269v.557a.671.671 0 101.342 0v-.557a7.96 7.96 0 007.249-7.269h.574a.671.671 0 100-1.342h-.571a7.916 7.916 0 00-7.252-7.269v-.557a.671.671 0 00-.671-.672zm1.725 9.84h1.216a3.021 3.021 0 01-2.27 2.27v-1.215a.671.671 0 10-1.342 0v1.212a3.023 3.023 0 01-2.27-2.27h1.215a.672.672 0 000-1.343h-1.215a3.021 3.021 0 012.27-2.266v1.212a.671.671 0 101.342 0V9.531a3.02 3.02 0 012.27 2.27h-1.216a.672.672 0 100 1.342zm-2.396-7.258v2.283a4.364 4.364 0 00-3.636 3.633H8.579a6.654 6.654 0 015.902-5.916zm-5.906 7.258h2.27a4.365 4.365 0 003.636 3.633v2.29a6.62 6.62 0 01-5.906-5.923zm7.248 5.923v-2.29a4.364 4.364 0 003.63-3.633h2.269a6.621 6.621 0 01-5.899 5.923zm4.029-11.27a6.523 6.523 0 011.873 4.005h-2.273a4.364 4.364 0 00-3.629-3.633v-2.29a6.52 6.52 0 014.029 1.917z"
            ></path>
            <path
                fill="#000"
                d="M15.343 0a12.27 12.27 0 00-12.27 12.14L.05 19.398a.672.672 0 00.564.927l2.8.241.793 6.265a.672.672 0 00.785.58l4.324-.67v2.588a.671.671 0 001.343 0V25.93a.67.67 0 00-.775-.671l-4.418.711-.773-6.113a.671.671 0 00-.614-.584l-2.427-.208 2.685-6.533a.672.672 0 00.05-.256 10.931 10.931 0 1117.572 8.699.671.671 0 00-.265.534v7.798a.671.671 0 101.343 0v-7.473A12.274 12.274 0 0015.343.013V0z"
            ></path>
        </svg>
    );
}

export default CustomerExperience;
